import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { SEND_HOURS, sendHourOption } from './send-hour';

/**
 * Picks the send hour of a notification schedule from 00:00–23:00. One
 * `onChange` per choice, so a choice is saved once. [HW-1071]
 *
 * `labelId` is the id of the text that names the field (e.g. "Send at"); a
 * screen reader announces the chosen hour as the combobox's value on its
 * own, so the name does not repeat it. A stored value that is not on the
 * list shows the placeholder; `''` (not undefined) keeps the Select
 * controlled, so it never shows a choice the server refused.
 */
export function SendHourSelect({
  value,
  onChange,
  disabled,
  labelId,
}: {
  value: string;
  onChange: (sendTime: string) => void;
  disabled?: boolean;
  labelId: string;
}) {
  return (
    <Select
      value={sendHourOption(value) ?? ''}
      onValueChange={(next) => {
        if (next !== value) onChange(next);
      }}
      disabled={disabled}
    >
      <SelectTrigger className="h-8 w-[92px]" aria-labelledby={labelId}>
        <SelectValue placeholder="--:--" />
      </SelectTrigger>
      <SelectContent>
        {SEND_HOURS.map((hour) => (
          <SelectItem key={hour} value={hour}>
            {hour}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
